import { Checkbox } from "primereact/checkbox";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { fetchData } from "../Cpanel/Components/Utilities";
import Cookies from "js-cookie";

Modal.setAppElement("#root");

const PrivacyModal = ({ isOpen, onRequestClose }) => {
  const [checked, setChecked] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const bodyFormData = new FormData()
  bodyFormData.append('guid', Cookies.get('guid'))
  const handleConfirmClose = () => {
    if (checked) {
      fetchData("rule", bodyFormData, handleApiResponse);
      onRequestClose();
    } else {
      setShowErrorMsg(true);
    }
  };

  const handleApiResponse =(data)=>{
    // console.log('ok');
  }
  const handleCheckboxChange = (e) => {
    setChecked(e.checked);
    if (e.checked) {
      setShowErrorMsg(false); // Hide error message when checkbox is checked
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleConfirmClose}
      style={modalStyles}
    >
      <div className="p-2">
        <h2>قوانین و مقررات سایت</h2>
        <p>
          استفاده نکردن از قابل های اماده بیان واضح و قابل فهم قواعد منصفانه
        </p>
        <p>
          بروزرسانی مقررات دسته بندی شرایط پوشش کامل فعالیت ها اطلاع دادن حفظ
        </p>
        <p>حریم شخصی مخاطبان نحوه برطرف کردن مشکلات پولی و مالی و تراکنش ها</p>
        {/* <Checkbox alt="accept privacy policy" value={acceptPolicy} placeholder="قوانین و مقررات سایت را قبول می کنم"/> */}
        <div className="d-flex gap-1 align-items-center">
          <Checkbox
            onChange={handleCheckboxChange}
            checked={checked}
            id="acceptCheckbox"
          />
          <label htmlFor="acceptCheckbox" className="text-color-light">
            قوانین و مقررات سایت را قبول می کنم.
          </label>
        </div>
        <div className="">
          {showErrorMsg && (
            <label htmlFor="acceptCheckbox" className="text-danger  t-12px">
              برای ورود قوانین را باید قبول کنید.
            </label>
          )}
        </div>
        <div className="w-100 d-flex justify-content-end align-items-center">
          <button
            className="btn btn-sm btn-primary"
            onClick={handleConfirmClose}
          >
            ذخیره
          </button>
        </div>
      </div>
    </Modal>
  );
};

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    padding: "20px",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

export default PrivacyModal;
